module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/banner/ko-6a5dd7ed05fc5d22f35c90e749e32763.jpg";